import Promise from 'bluebird';
export var trimDoubleSlash = function (url) {
    if (url) {
        return url.replace(/^\/\//, '/');
    }
    return url;
};
export var ensureSPClientContext = new Promise(function (resolve) {
    SP.SOD.executeFunc('sp.js', 'SP.ClientContext', resolve);
});
